import React from 'react';
import classNames from 'classnames';

const LoaderVariants: Record<string, React.ComponentProps<'div'>['className']> =
  {
    primary:
      'primaryLoaderBackground primaryAnimationColor text-xs text-text-secondary rounded-lg p-2 items-center',
    secondary:
      'secondaryLoaderBackground secondaryAnimationColor text-ml rounded-lg p-6 text-text-secondary',
  };

type LoaderProps = {
  className?: string;
  text?: string;
  variant?: keyof typeof LoaderVariants;
};

export const Loader = ({
  className,
  text = '',
  variant = 'primary',
}: LoaderProps) => {
  return (
    <div
      className={classNames(
        `loaderBase flex max-w-full`,
        LoaderVariants[variant],
        className
      )}
    >
      {text}
    </div>
  );
};
